import React from 'react';
import CreateProductPage from '../../../../../components/page/products/CreateProductPage';

export default function CreateProductVendor() {
	return (
		<>
			<CreateProductPage />
		</>
	);
}
